const GiftsCarouselData = [
    {
        title: 'The Listner',
        img: 'https://i.ibb.co/K69Jzv4/Aesop-Kits-Gift-Kits-2021-22-The-Listener-Web-Large-1584x962px.png',
        text:'Cleanser, Bulb, Scrub'
    },
    {
        title: 'The Froger',
        img: 'https://i.ibb.co/RctSq14/Aesop-Kits-Gift-Kits-2021-22-The-Forager-Web-Large-1584x962px.png',
        text:'Two innovative stcaples'
    },
    {
        title: 'The Advocate',
        img: 'https://i.ibb.co/54jkTy0/Aesop-Kits-Gift-Kits-2021-22-The-Advocate-Web-Large-1584x962px.png',
        text:'Four hand and body care staples'
    },
    {
        title: 'The Mentor',
        img: 'https://i.ibb.co/QvWFKRZ/Aesop-Kits-Gift-Kits-2021-22-The-Mentor-Web-Large-1584x962px.png',
        text:'Cleaner, toner, hybridic scrum'
    }
]

export default GiftsCarouselData;